import { Info } from "lucide-react";
import type { FC } from "react";

type PasswordListProps = {
  policy: {
    requireUppercase: boolean;
    requireLowercase: boolean;
    requireNumber: boolean;
    requireSymbol: boolean;
    minLength: number;
  } | null;
  translations: {
    intro: string;
    capitalLetter: string;
    lowercaseLetter: string;
    number: string;
    specialCharacter: string;
    minimumLength: string;
  };
};

export const PasswordList: FC<PasswordListProps> = ({
  policy,
  translations,
}) => {
  if (!policy) return null;

  const parts: string[] = [];

  if (policy.requireUppercase) parts.push(translations.capitalLetter);
  if (policy.requireLowercase) parts.push(translations.lowercaseLetter);
  if (policy.requireNumber) parts.push(translations.number);
  if (policy.requireSymbol) parts.push(translations.specialCharacter);
  if (policy.minLength) parts.push(translations.minimumLength);
  if (parts.length < 1) return null;
  return (
    <div className="flex gap-2 items-start">
      <Info size={24} />
      <p className="text-sm">
        <span className="font-medium">{translations.intro}</span>{" "}
        {parts.join(", ")}
      </p>
    </div>
  );
};
